const pageRoutes = [
  {
    name: "Ecosystem",
    route: "#ecosystem",
  },
  {
    name: "Community",
    route: "#community",
  },
  {
    name: "Team",
    route: "#team",
  },
  {
    name: "Roadmap",
    route: "#roadmap",
  },
  {
    name: "FAQ",
    route: "#faq",
  },
];

export default pageRoutes;
